var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlarna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -9 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "#F4B6C7",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.413 25.796H5V15h2.413v10.796zM13.44 15h-2.362c0 1.987-.89 3.81-2.44 5.003l-.936.72 3.624 5.074h2.98l-3.335-4.67c1.582-1.615 2.469-3.79 2.469-6.127zm3.849 10.793H15.01v-10.79h2.279v10.79zm6.888-7.464v.477a3.747 3.747 0 00-2.159-.684c-2.119 0-3.837 1.764-3.837 3.94 0 2.174 1.718 3.938 3.837 3.938.801 0 1.544-.253 2.159-.684v.477h2.177V18.33h-2.177zm-.008 3.732c0 1.06-.883 1.92-1.972 1.92-1.09 0-1.973-.86-1.973-1.92s.883-1.92 1.973-1.92 1.972.86 1.972 1.92zm22.976-3.255v-.477h2.178v7.464h-2.178v-.477a3.748 3.748 0 01-2.158.684c-2.119 0-3.837-1.764-3.837-3.939s1.718-3.939 3.837-3.939c.801 0 1.543.253 2.158.684zm-1.98 5.176c1.09 0 1.973-.86 1.973-1.92 0-1.062-.883-1.921-1.973-1.921s-1.972.86-1.972 1.92.883 1.92 1.972 1.92zm5.102.566c0-.774.612-1.402 1.367-1.402.754 0 1.366.628 1.366 1.402 0 .775-.612 1.403-1.366 1.403-.755 0-1.367-.628-1.367-1.403zm-12.986-6.42c-.87 0-1.692.277-2.243 1.042v-.841h-2.167v7.464h2.194v-3.922c0-1.136.742-1.691 1.634-1.691.957 0 1.507.586 1.507 1.675v3.938h2.175v-4.747c0-1.737-1.346-2.918-3.1-2.918zm-7.56.2v.973c.437-.583 1.25-.972 2.135-.972v2.172H31.83c-.862 0-2.103.631-2.103 1.807v3.485h-2.234V18.33h2.229z",
    fill: "#17120F"
  })));
}
export default SvgKlarna;